function Sort2() {
  return (
    <svg width={29} height={40} viewBox="0 0 29 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.418 23.215h23.914c2.15 0 3.225 2.603 1.708 4.12L16.083 39.292a2.402 2.402 0 01-3.406 0L.71 27.335c-1.517-1.517-.442-4.12 1.708-4.12zm25.622-10.55L16.083.708a2.402 2.402 0 00-3.406 0L.71 12.665c-1.517 1.517-.442 4.12 1.708 4.12h23.914c2.15 0 3.225-2.603 1.708-4.12z"
        fill="#2C2C2C"
      />
    </svg>
  );
}

export default Sort2;
